import { useSearchParams, Link } from 'react-router-dom'
import { ChevronRight, Search } from 'lucide-react'
import { useProducts } from '@/modules/products-api'
import { ProductCard } from '@/modules/products/ui/components/ProductCard'
import type { ApiProduct } from '@/modules/products-api'
import type { Product } from '@/modules/products/model/types'

function toLegacy(p: ApiProduct): Product {
  return {
    id: p.id, slug: p.slug, name: p.name, categorySlug: p.categorySlug,
    brand: p.brand, price: p.price, oldPrice: p.oldPrice, discountPct: p.discountPct,
    image: p.image, images: p.images, rating: p.rating, reviews: p.reviews,
    inStock: p.inStock, shortDesc: p.shortDesc ?? undefined, specs: (p.specs ?? undefined),
  }
}

export function SearchPage() {
  const [sp] = useSearchParams()
  const q = sp.get('q') || ''

  const { data, isLoading } = useProducts({ q, limit: 50 })
  const items = data?.items ?? []

  return (
    <div className="max-w-[1440px] mx-auto px-6 py-6">
      <nav className="flex items-center gap-1.5 text-sm text-muted mb-4">
        <Link to="/" className="hover:text-brand-600">Trang chủ</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-text font-medium">Kết quả tìm kiếm</span>
      </nav>

      <div className="mb-5">
        <h1 className="text-2xl font-bold text-text">
          Kết quả cho: <span className="text-brand-700">"{q}"</span>
        </h1>
        {!isLoading && (
          <p className="text-sm text-muted mt-1">
            Tìm thấy <span className="font-semibold text-text">{items.length}</span> sản phẩm
          </p>
        )}
      </div>

      {isLoading && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="aspect-[3/4] bg-slate-100 rounded-xl animate-pulse" />
          ))}
        </div>
      )}

      {!isLoading && items.length === 0 && (
        <div className="bg-surface border border-border rounded-xl p-16 text-center">
          <Search className="w-16 h-16 mx-auto text-slate-300 mb-3" />
          <div className="text-lg font-semibold text-text">Không tìm thấy sản phẩm</div>
          <p className="text-muted text-sm mt-1">Thử với từ khóa khác hoặc xem toàn bộ sản phẩm.</p>
          <Link to="/danh-muc/xe-may-dien" className="mt-4 inline-flex h-10 px-5 rounded-md bg-brand-600 hover:bg-brand-700 text-white font-medium text-sm items-center">
            Xem tất cả
          </Link>
        </div>
      )}

      {!isLoading && items.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((p) => <ProductCard key={p.id} product={toLegacy(p)} />)}
        </div>
      )}
    </div>
  )
}
